import './App.css';
import ErrorNotifier from './components/elements/ErrorNotifier';
import SuccessNotifier from './components/elements/SuccessNotifier';
import { Provider } from 'react-redux';
import store from './store/store';
import ScrollToTop from './components/layouts/ScrollToTop';
import { Navigate, Route, Routes } from 'react-router-dom';
import Login from './pages/auth/Login';
import PasswordReset from './pages/auth/PasswordReset';
import EmailConfirmation from './pages/onboarding/EmailConfirmation';
import User from './pages/User';
import Home from './pages/user/Home';
import UserErrorPage from './pages/user/UserErrorPage';
import ErrorPage from './pages/ErrorPage';
import Applications from './pages/user/applications/Applications';
import Application from './pages/user/applications/Application';
import Signup from './pages/onboarding/Signup';
import Payments from './pages/user/Payments';
import AdmissionDetails from './pages/user/admissions/AdmissionDetails';
import VerifyPayment from './pages/user/VerifyPayment';
import NewApplication from './pages/user/applications/NewApplication';
import AdmissionOffer from './pages/user/admission-offers/AdmissionOffer';
import Students from './pages/user/students/Students';
import Student from './pages/user/students/Student';
import Notifications from './pages/user/Notifications';
import Downloadables from './pages/user/Downloadables';
import CreateNewPassword from './pages/auth/CreateNewPassword';
import UserProfile from './pages/user/UserProfile';
import UpdateMedicals from './pages/user/admission-offers/UpdateMedicals';

function App() {
  return (
    <main>
    <Provider store={store}>
      <ErrorNotifier />
      <SuccessNotifier />
      <ScrollToTop>

          <Routes>
            <Route path="/" exact element={<Login />} />
            <Route path="/password-reset" exact element={<PasswordReset />} />
            <Route path="/create-password/:resetCode" exact element={<CreateNewPassword />} />

            <Route path="/signup" exact element={<Signup />} />
            <Route path="/confirm-email/:confirmationCode" exact element={<EmailConfirmation />} />
            
            <Route path="/user" element={<User />}>
              <Route path="/user/" element={<Navigate replace to="/user/home" />} />
              <Route path="/user/home" element={<Home />} />
              <Route path="/user/notifications" element={<Notifications />} />
              <Route path="/user/admissions/:admissionId" element={<AdmissionDetails />} />
              <Route path="/user/admission-offers/:admissionOfferId" element={<AdmissionOffer />} />
              <Route path="/user/admission-offers/:admissionOfferId/medicals" element={<UpdateMedicals />} />
              <Route path="/user/verify-payment" element={<VerifyPayment />} />

              <Route path="/user/applications" element={<Applications />} />
              <Route path="/user/applications/application/:applicationId" element={<Application />} />
              <Route path="/user/applications/new-application/:admissionId" element={<NewApplication />} />
              
              <Route path="/user/students" element={<Students />} />
              <Route path="/user/students/student/:studentId" element={<Student />} />

              <Route path="/user/payments" element={<Payments />} />

              <Route path="/user/downloadables" element={<Downloadables />} />
              <Route path="/user/profile" element={<UserProfile />} />
              
              <Route path="/user/*" element={<UserErrorPage />} />
            </Route>
            <Route path="*" element={<ErrorPage />} />
          </Routes>
        </ScrollToTop>
    </Provider>
    </main>
  );
}

export default App;
